import { render, staticRenderFns } from "./InfoSet.vue?vue&type=template&id=54a25d30&scoped=true&"
import script from "./InfoSet.vue?vue&type=script&lang=js&"
export * from "./InfoSet.vue?vue&type=script&lang=js&"
import style0 from "./InfoSet.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InfoSet.vue?vue&type=style&index=1&id=54a25d30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a25d30",
  null
  
)

export default component.exports